import RecentCourseCard from './RecentCourseCard';

export default RecentCourseCard;
